export const DASHBOARD = 'dashboard';
export const PLAY = 'play';
// export const SUMMARY_DASHBOARD = 'summary';
export const EXCEPTION_RULES = 'exceptionRules';
export const EXCEPTION_ALERTS = 'exceptionAlerts';
export const SHIPPING_MANAGEMENT = 'shippingManagement';
export const RFQ = 'rfqShipper';
export const BIDDING = 'rfqShippingLine';
export const DOMESTIC = 'ltl';
export const NEW_EXPORTS = 'newExports';
export const NEW_IMPORTS = 'newImports';
export const SETUP = 'setup';
export const TRIANGULATION = 'triangulation';
export const MY_ACCOUNT = 'account';
export const INQUIRY = 'inquiry';
export const PROCURE = 'procure';
export const QUOTE = 'quote';
export const INVOICE = 'invoice';
export const EXECUTION = 'execution';
export const BULK_REQUEST = 'bulkRequest';
// export const RFQ_BULK_REQUEST = 'rfqBulkRequest';
export const DISCOVER_RATES = 'discoverRates';
export const VESSEL_SCHEDULES  = 'vesselSchedules';
export const ANALYTICS = 'analytics';
export const RATE_MASTER = 'rateMaster';
